module.exports = __webpack_public_path__ + "img/camera.8d373349.svg";